import styled from 'styled-components';

export const HeaderLink = styled.h4`
position:relative;
margin-right:45px;
font-size:18px;
cursor:pointer;
color:${props => props.isSelected ? '#7918F2' : 'white'};

&::after {
    content: '';
    position: absolute;
    left: 20px;
    top: 30px;
    width: 0;
    height: 0;
    border-left: ${props => props.isSelected && '6px solid transparent'}; 
    border-right: ${props => props.isSelected && '6px solid transparent'}; 
    border-top: 6px solid #7918F2;
    clear: both;
    transform: rotate(180deg);
    
  }
transition: all 0.4s ease;

@media(max-width: 800px) {
  margin-right:15px;
  font-size:16px;
}
`;

export const HeaderWrapper = styled.div`
background-color:#000000;
display:flex;
justify-content:space-between;
align-items:center;

@media(max-width: 800px) {
  flex-direction: column;
  margin-left:100px;
  position: relative;
}
`

export const LogoWrapper = styled.div`
margin: 25px 0px 10px 80px;
height: 60px;
`

export const ButtonHeaderRight = styled.button`
height: 45px;
width: 152px;
background: linear-gradient(90deg, #AC32E4 0%, #7918F2 48%, #4801FF 100%);
color: white;
font-size: 16px;
fontWeight: bold;
border: none;
font-weight:700;
font-family:Poppins;
`

export const LinksWrapper = styled.div`
color: white;
display: flex;
margin-right: 98px;
align-items: center;

@media(max-width: 800px) {
  margin-right: 10px;
}
`